import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksPhotos(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTOS,
		options
	)
}
function _getDoneWorksPhotoPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_PREVIEW,
		options
	)
}
function _getDoneWorksPhotoPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_POPUP,
		options
	)
}

function _createDoneWorksPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].CREATE_DONE_WORKS_PHOTO,
		options
	)
}

function _getDoneWorksPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO,
		options
	)
}

function _patchDoneWorksPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PATCH_DONE_WORKS_PHOTO,
		options
	)
}

function _putDoneWorksPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PUT_DONE_WORKS_PHOTO,
		options
	)
}

function _deleteDoneWorksPhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_PHOTOS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].DELETE_DONE_WORKS_PHOTO,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTOS]: _getDoneWorksPhotos,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_PREVIEW]: _getDoneWorksPhotoPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO_POPUP]: _getDoneWorksPhotoPopup,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].CREATE_DONE_WORKS_PHOTO]: _createDoneWorksPhoto,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].GET_DONE_WORKS_PHOTO]: _getDoneWorksPhoto,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PATCH_DONE_WORKS_PHOTO]: _patchDoneWorksPhoto,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].PUT_DONE_WORKS_PHOTO]: _putDoneWorksPhoto,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_PHOTOS].DELETE_DONE_WORKS_PHOTO]: _deleteDoneWorksPhoto,
}